import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import AgenteDeIaParaWhatsapp from "@/pages/AgenteDeIaParaWhatsapp";

export const Route = createFileRoute("/agente-de-ia-para-whatsapp")({
  head: () => buildHead({
    title: "Agente de IA para WhatsApp: o que é, quanto custa e como implantar",
    description: "Guia completo do agente de IA para WhatsApp e Instagram: como funciona, diferença para chatbot, preços, integração com CRM e passo a passo de implantação.",
    path: "/agente-de-ia-para-whatsapp",
  }),
  component: AgenteDeIaParaWhatsapp,
});
